import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export const ProductCard = ({ product, index = 0 }) => {
  const { isArabic } = useLanguage();
  
  // Get the first image or use a placeholder
  const imageUrl = product.images && product.images.length > 0 
    ? product.images[0] 
    : 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      className="group bg-white border border-slate-100 rounded-xl overflow-hidden card-hover"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-slate-50">
        <img
          src={imageUrl}
          alt={isArabic ? product.nameAr : product.nameEn}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600';
          }}
        />
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className={`text-base font-semibold text-slate-900 mb-2 line-clamp-1 ${isArabic ? 'font-arabic' : 'font-english'}`}>
          {isArabic ? product.nameAr : product.nameEn}
        </h3>
        <p className="text-sm text-slate-500 line-clamp-2">
          {isArabic ? product.descAr : product.descEn}
        </p>
      </div>
    </motion.div>
  );
};

export default ProductCard;
